(() => {
  const blockSelector = '[data-kfa-edition]';

  function clampRemaining(inventoryQuantity, editionSize) {
    if (!Number.isFinite(inventoryQuantity) || !Number.isFinite(editionSize) || editionSize <= 0) return 0;
    return Math.max(0, Math.min(inventoryQuantity, editionSize));
  }

  function updateBlock(block, variantId) {
    if (!block || !variantId) return;

    const variant = block.querySelector(
      `[data-kfa-edition-variant][data-variant-id="${CSS.escape(String(variantId))}"]`
    );
    if (!variant) return;

    const editionSize = Number(variant.dataset.editionSize || 0);
    const apCount = Number(variant.dataset.apCount || 0);
    const inventoryQuantity = Number(variant.dataset.inventoryQuantity || 0);
    const remaining = clampRemaining(inventoryQuantity, editionSize);
    const primary = block.querySelector('[data-kfa-edition-primary]');
    const availability = block.querySelector('[data-kfa-edition-availability]');

    if (!primary || !availability) return;

    if (editionSize > 0) {
      primary.textContent = `EDITION ${editionSize} + ${apCount} AP`;
      if (remaining > 2) {
        availability.textContent = block.dataset.labelAvailable;
      } else if (remaining === 2) {
        availability.textContent = block.dataset.labelLow;
      } else if (remaining === 1) {
        availability.textContent = block.dataset.labelFinal;
      } else {
        availability.textContent = block.dataset.labelClosed;
      }
      block.dataset.editionClosed = remaining > 0 ? 'false' : 'true';
    } else {
      primary.textContent = block.dataset.labelFormat;
      availability.textContent = block.dataset.labelRequest;
      block.dataset.editionClosed = 'false';
    }
  }

  function initialise(root = document) {
    root.querySelectorAll(blockSelector).forEach((block) => {
      updateBlock(block, block.dataset.initialVariantId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('variant:update', (event) => {
    const variantId = event.detail?.resource?.id;
    const productId = String(event.detail?.data?.productId || '');
    if (!variantId) return;

    document.querySelectorAll(blockSelector).forEach((block) => {
      if (productId && block.dataset.productId !== productId) return;
      updateBlock(block, variantId);
    });
  });

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
